export default "__VITE_ASSET__684553e2__"